"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexedDbLocalDataStore = exports.openOfflineDatabase = exports.STORE_SYNC_QUEUE = exports.STORE_SNAPSHOTS = exports.OFFLINE_DB_VERSION = exports.OFFLINE_DB_NAME = void 0;
exports.OFFLINE_DB_NAME = 'audroam.offline';
exports.OFFLINE_DB_VERSION = 1;
exports.STORE_SNAPSHOTS = 'snapshots';
exports.STORE_SYNC_QUEUE = 'syncQueue';
var OFFLINE_OBJECT_STORES = (_a = {},
    _a[exports.STORE_SNAPSHOTS] = {},
    _a[exports.STORE_SYNC_QUEUE] = { keyPath: 'id' },
    _a);
function idbError(message, cause) {
    if (!cause) {
        return new Error(message);
    }
    return Object.assign(new Error("".concat(message, ": ").concat(cause.message)), { cause: cause });
}
function idbRequest(request) {
    return new Promise(function (resolve, reject) {
        request.onsuccess = function () { return resolve(request.result); };
        request.onerror = function () { return reject(idbError('IndexedDB request failed', request.error)); };
    });
}
function idbTransaction(tx) {
    return new Promise(function (resolve, reject) {
        tx.oncomplete = function () { return resolve(); };
        tx.onerror = function () { return reject(idbError('IndexedDB transaction failed', tx.error)); };
        tx.onabort = function () { return reject(idbError('IndexedDB transaction aborted', tx.error)); };
    });
}
function ensureOfflineObjectStores(db) {
    Object.entries(OFFLINE_OBJECT_STORES).forEach(function (_a) {
        var storeName = _a[0], schema = _a[1];
        if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName, schema.keyPath ? { keyPath: schema.keyPath } : undefined);
        }
    });
}
function openOfflineDatabase(idb) {
    if (idb === void 0) { idb = indexedDB; }
    return new Promise(function (resolve, reject) {
        var request = idb.open(exports.OFFLINE_DB_NAME, exports.OFFLINE_DB_VERSION);
        request.onupgradeneeded = function () { return ensureOfflineObjectStores(request.result); };
        request.onsuccess = function () { return resolve(request.result); };
        request.onerror = function () { return reject(idbError('Failed to open offline database', request.error)); };
    });
}
exports.openOfflineDatabase = openOfflineDatabase;
var IndexedDbLocalDataStore = /** @class */ (function () {
    function IndexedDbLocalDataStore(openDb) {
        if (openDb === void 0) { openDb = openOfflineDatabase; }
        this.openDb = openDb;
        this.dbPromise = null;
    }
    IndexedDbLocalDataStore.prototype.connect = function () {
        if (!this.dbPromise) {
            this.dbPromise = this.openDb();
        }
        return this.dbPromise;
    };
    IndexedDbLocalDataStore.prototype.withStore = function (storeName, mode, work) {
        return __awaiter(this, void 0, void 0, function () {
            var database, tx, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connect()];
                    case 1:
                        database = _a.sent();
                        tx = database.transaction(storeName, mode);
                        return [4 /*yield*/, work(tx.objectStore(storeName))];
                    case 2:
                        result = _a.sent();
                        return [4 /*yield*/, idbTransaction(tx)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    IndexedDbLocalDataStore.prototype.get = function (storeName, key) {
        var _this = this;
        return this.withStore(storeName, 'readonly', function (store) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, idbRequest(store.get(key))];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, (value !== null && value !== void 0 ? value : null)];
                }
            });
        }); });
    };
    IndexedDbLocalDataStore.prototype.put = function (storeName, key, value) {
        return this.withStore(storeName, 'readwrite', function (store) {
            store.put(value, key);
        });
    };
    IndexedDbLocalDataStore.prototype.delete = function (storeName, key) {
        return this.withStore(storeName, 'readwrite', function (store) {
            store.delete(key);
        });
    };
    IndexedDbLocalDataStore.prototype.getAll = function (storeName) {
        var _this = this;
        return this.withStore(storeName, 'readonly', function (store) { return __awaiter(_this, void 0, void 0, function () {
            var values;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, idbRequest(store.getAll())];
                    case 1:
                        values = _a.sent();
                        return [2 /*return*/, values !== null && values !== void 0 ? values : []];
                }
            });
        }); });
    };
    IndexedDbLocalDataStore.prototype.deleteByPrefix = function (storeName, keyPrefix) {
        var _this = this;
        return this.withStore(storeName, 'readwrite', function (store) { return __awaiter(_this, void 0, void 0, function () {
            var keys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, idbRequest(store.getAllKeys())];
                    case 1:
                        keys = _a.sent();
                        keys.forEach(function (key) {
                            if (typeof key === 'string' && key.startsWith(keyPrefix)) {
                                store.delete(key);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return IndexedDbLocalDataStore;
}());
exports.IndexedDbLocalDataStore = IndexedDbLocalDataStore;
